import { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Header.module.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.logo}>
          <Link to="/" className={styles.logoLink}>
            <img src="/favicon.svg" alt="Animase Logo" width="40" height="40" />
            <span className={styles.logoText}>Animase</span>
          </Link>
        </div>

        <button 
          className={`${styles.menuToggle} ${isMenuOpen ? styles.menuOpen : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`${styles.nav} ${isMenuOpen ? styles.navOpen : ''}`}>
          <ul className={styles.navList}>
            <li className={styles.navItem}><Link to="/" className={styles.navLink}>Home</Link></li>
            <li className={styles.navItem}><Link to="/explore" className={styles.navLink}>Explore</Link></li>
            <li className={styles.navItem}><Link to="/seasonal" className={styles.navLink}>Seasonal</Link></li>
            <li className={styles.navItem}><Link to="/genres" className={styles.navLink}>Genres</Link></li>
            <li className={styles.navItem}><Link to="/about" className={styles.navLink}>About</Link></li>
          </ul>
          
          <div className={styles.auth}>
            <Link to="/login" className={styles.loginButton}>Login</Link>
            <Link to="/register" className={styles.registerButton}>Sign Up</Link>
          </div>
        </nav>

        <div className={styles.actions}>
          <form className={styles.searchForm}>
            <input 
              type="text" 
              className={styles.searchInput} 
              placeholder="Search anime..." 
              aria-label="Search anime"
            />
            <button type="submit" className={styles.searchButton} aria-label="Search">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M21 21L16.65 16.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </form>
          
          <div className={styles.auth}>
            <Link to="/login" className={styles.loginButton}>Login</Link>
            <Link to="/register" className={styles.registerButton}>Register</Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 